import { render, staticRenderFns } from "./menopausejbfx.vue?vue&type=template&id=ba9878e2&scoped=true&"
import script from "./menopausejbfx.vue?vue&type=script&lang=js&"
export * from "./menopausejbfx.vue?vue&type=script&lang=js&"
import style0 from "./menopausejbfx.vue?vue&type=style&index=0&id=ba9878e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9878e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba9878e2')) {
      api.createRecord('ba9878e2', component.options)
    } else {
      api.reload('ba9878e2', component.options)
    }
    module.hot.accept("./menopausejbfx.vue?vue&type=template&id=ba9878e2&scoped=true&", function () {
      api.rerender('ba9878e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menopauseovary/components/menopausejbfx.vue"
export default component.exports